/** @jsxImportSource @emotion/react */

import { useQuery } from '@apollo/client'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { useParams } from 'react-router-dom'
import { findAllPlatforms, findAllPlatformsVariables } from '__generatedTypes__/findAllPlatforms'
import { TAKE_ALL_ITEMS_COUNT } from 'constants/consts'
import { GET_PLATFORMS } from 'queries/common'
import { formatPlatformsWithKeys } from 'utils/formatPlatformsWithKeys'
import { PageLoader } from 'components/PageLoader'

// eslint-disable-next-line react/display-name, @typescript-eslint/no-explicit-any
const withPlatformCheck = (Component: any) => (props: any) => {
  const { platform } = useParams()

  const { data: platformsData, loading: platformsLoading } = useQuery<findAllPlatforms, findAllPlatformsVariables>(
    GET_PLATFORMS,
    {
      variables: { query: { take: TAKE_ALL_ITEMS_COUNT } },
    }
  )

  const platforms = formatPlatformsWithKeys(platformsData?.findAllPlatforms.items || [])

  const selectedPlatform = platforms?.find((p) => p.key === platform)

  if (platformsLoading) {
    return (
      <Paper sx={{ p: 4, mt: 2 }}>
        <PageLoader />
      </Paper>
    )
  }

  //TODO Error state
  if (!selectedPlatform) {
    return (
      <Paper sx={{ p: 4, mt: 2 }}>
        <Typography>Error...</Typography>
      </Paper>
    )
  }

  return <Component {...props} platform={selectedPlatform} />
}

export default withPlatformCheck
